import { render, staticRenderFns } from "./LinkClaims.vue?vue&type=template&id=3487d3b4&scoped=true"
import script from "./LinkClaims.vue?vue&type=script&lang=js"
export * from "./LinkClaims.vue?vue&type=script&lang=js"
import style0 from "./LinkClaims.vue?vue&type=style&index=0&id=3487d3b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3487d3b4",
  null
  
)

export default component.exports